<template>
  <label class="form-control-checkbox" :class="{'checkbox-disabled': disabled,'checkbox-checked': checked}">
    <input :value="label" type="checkbox" v-model="model">
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    value: {},
    label: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    checked() {
      return this.value.includes(this.label);
    },
  },
};
</script>